var React = require('react');

function IconPenSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.2 773.3v186.3h186.3l549.3-549.3L613.5 224 64.2 773.3zm879.6-507.1c19.4-19.4 19.4-50.7 0-70L827.6 79.9c-19.4-19.4-50.7-19.4-70 0l-90.9 90.9L853 357.1l90.8-90.9z"}));
}

IconPenSolid.displayName = "IconPenSolid";

IconPenSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPenSolid;

IconPenSolid.default = IconPenSolid;
